import styled from 'styled-components';

import { Text } from '@/nova/components/Text/Text';
import { ANIM, COLORS } from '@/nova/theme/tokens';

/* The gamification picker: a multi-select grid of the brand's ACTIVE features (logo + name) + a confirm
   footer. No tabs/pagination (the active set is small). Colours/timings come only from theme tokens. */

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 12px;
  max-height: 56vh;
  overflow-y: auto;
  padding: 2px;
`;

export const FeatureCard = styled.button<{ $disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.4 : 1)};
  text-align: left;
  transition: opacity ${ANIM.INTERACT_MS}ms ${ANIM.EASE};
`;

export const Thumb = styled.div<{ $selected: boolean }>`
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 12px;
  overflow: hidden;
  background: ${COLORS.surfaceInset};
  border: 2px solid ${({ $selected }) => ($selected ? COLORS.accent : COLORS.hairline)};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px;
  transition: border-color ${ANIM.INTERACT_MS}ms ${ANIM.EASE};
`;

export const ThumbImg = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  display: block;
`;

export const Check = styled.span`
  position: absolute;
  top: 6px;
  right: 6px;
  width: 22px;
  height: 22px;
  border-radius: 999px;
  background: ${COLORS.accent};
  color: ${COLORS.onAccent};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Name = styled(Text).attrs({ tag: 'span' as const })`
  font-size: 12px;
  color: ${COLORS.text};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 2px;
`;

export const Note = styled(Text).attrs({ tag: 'paragraph' as const })`
  font-size: 13px;
  color: ${COLORS.textFaint};
  padding: 20px 0;
  text-align: center;
`;

export const FooterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const SelCount = styled(Text).attrs({ tag: 'span' as const })`
  font-size: 13px;
  color: ${COLORS.textMuted};
`;

export const FooterActions = styled.div`
  display: flex;
  gap: 8px;
`;
